var $export = require(68);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require(64), 'Object', { defineProperties: require(94) });
